import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';

const Pagination = props => {
  const {
   // onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  

  const onNext = () => {
    props.onPageChange(currentPage + 1);
  };

  const onPageChange = (x) => {
      props.onPageChange(x);
  }

  const onPrevious = () => {
    props.onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div>

{/*
      <p>Debug: currentPage: {currentPage} totalCount: {totalCount} pageSize: {pageSize} </p>
*/}  
      <ul
        className={classnames('pagination-container', { [className]: className })}
      >
        <li key={'pn-first'}
          className={classnames('pagination-item', {
            disabled: currentPage === 1
          })}
          onClick={onPrevious}
        >
          <div className="arrow left" />
        </li>
        {paginationRange.map((pageNumber, key) => {
          if (pageNumber === DOTS) {
            return <li key={'pndots-' + pageNumber + '-' + key} className="pagination-item dots">&#8230;</li>;
          }

          return (
            <li key={'pn-' + pageNumber}
              className={classnames('pagination-item', {
                selected: pageNumber === currentPage
              })}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </li>
          );
        })}
        <li key={'pn-last'}
          className={classnames('pagination-item', {
            disabled: currentPage === lastPage
          })}
          onClick={onNext}
        >
          <div className="arrow right" />
        </li>
      </ul>
    </div>
  );
};

export default Pagination;